// Matches Supabase Auth's own default minimum -- kept as one constant
// since it's asserted client-side in two places (sign-up and
// reset-password) and previously drifted into two separate copies of
// both the number and the "At least 6 characters" copy.
export const MIN_PASSWORD_LENGTH = 6;
